import React from "react";
import { Building2, Target, Eye, Users, Award, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const LEADERS = [
  { name: "Sh. Rajinder Singh", role: "Chief Executive Officer (CEO)" },
  { name: "Smt. Harpreet Kaur", role: "Director – Programmes" },
  { name: "Sh. Manpreet Sandhu", role: "Executive Engineer" },
  { name: "Sh. Amanpreet Gill",  role: "Finance Controller" },
];

export default function AboutPage() {
  return (
    <div>
      <div className="hero-punjab text-white relative overflow-hidden">
        <div className="absolute inset-0 grain pointer-events-none"/>
        <div className="container-x py-16">
          <div className="label-tiny text-[hsl(var(--accent))]">About PEDA</div>
          <h1 className="mt-2 text-4xl lg:text-5xl font-heading font-bold">Punjab Energy Development Agency</h1>
          <p className="mt-4 max-w-2xl text-white/80">
            PEDA is the state nodal agency of the Government of Punjab responsible for promoting renewable energy sources and energy conservation across the state. Established under the Government of Punjab, it drives Punjab's transition to a sustainable clean-energy economy.
          </p>
        </div>
      </div>

      <section className="container-x py-16 grid lg:grid-cols-3 gap-6">
        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="h-11 w-11 rounded-lg bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] grid place-items-center"><Target className="h-5 w-5"/></div>
          <h3 className="mt-4 font-heading font-bold text-xl">Mission</h3>
          <p className="mt-2 text-sm text-muted-foreground">Accelerate adoption of renewable energy and energy-efficient technologies to build a self-reliant, low-carbon Punjab.</p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="h-11 w-11 rounded-lg bg-[hsl(var(--accent))]/15 text-[hsl(var(--accent))] grid place-items-center"><Eye className="h-5 w-5"/></div>
          <h3 className="mt-4 font-heading font-bold text-xl">Vision</h3>
          <p className="mt-2 text-sm text-muted-foreground">A prosperous Punjab powered by clean, affordable and reliable renewable energy across every home, farm and factory.</p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="h-11 w-11 rounded-lg bg-sky-500/10 text-sky-500 grid place-items-center"><Award className="h-5 w-5"/></div>
          <h3 className="mt-4 font-heading font-bold text-xl">Mandate</h3>
          <p className="mt-2 text-sm text-muted-foreground">Nodal implementation of MNRE, BEE and Punjab Government schemes; policy execution, capacity building, monitoring, and public awareness.</p>
        </div>
      </section>

      <section id="leadership" className="container-x pb-16">
        <div className="label-tiny text-[hsl(var(--primary))]">Leadership</div>
        <h2 className="mt-1 text-3xl font-heading font-bold">Our team</h2>
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {LEADERS.map((l) => (
            <div key={l.name} className="rounded-xl border border-border bg-card p-5">
              <div className="h-14 w-14 rounded-full bg-peda-navy text-white grid place-items-center font-heading font-bold">
                {l.name.split(" ").map(w=>w[0]).slice(0,2).join("")}
              </div>
              <div className="mt-3 font-heading font-semibold">{l.name}</div>
              <div className="text-xs text-muted-foreground mt-1">{l.role}</div>
            </div>
          ))}
        </div>
      </section>

      <section id="org" className="container-x pb-24">
        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="label-tiny">Organization Chart</div>
          <div className="mt-6 grid gap-3">
            <div className="mx-auto rounded-lg bg-peda-navy text-white px-4 py-2 text-sm font-semibold">CEO</div>
            <div className="grid grid-cols-3 gap-3">
              {["Director - Programmes","Director - Finance","Director - Administration"].map(x=>(
                <div key={x} className="rounded-lg bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] px-3 py-2 text-sm text-center">{x}</div>
              ))}
            </div>
            <div className="grid grid-cols-4 gap-3">
              {["Solar Wing","Biogas & CBG","EV & Street Light","Waste-to-Energy"].map(x=>(
                <div key={x} className="rounded-lg border border-border px-3 py-2 text-sm text-center">{x}</div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
